import {apis} from '@doltech/core/lib/api/api.config';
import {apiCacheKeys, apiUrls} from '@doltech/core/lib/api/api.urls';
import {queryClient} from '@doltech/core/lib/hooks/withReactQueryConfig';
import {showToast} from '@doltech/ui/lib/figma/Toast';
import {stringifyEditorFields} from '@doltech/utils/lib/object';
import {noop} from 'lodash';

const transformDetail = (data) => {
  (data as any).topicId = data?.topic?.id;
  return data;
};

const processUpdateOrPublishDailyVocabs = async ({ payload, onSuccess = noop, apiFn }) => {
  try {
    stringifyEditorFields(payload, ['memorization', 'example']);

    const res = await apiFn({
      id: payload.id,
      payload,
    });
    queryClient.setQueryData(
      [apiCacheKeys.onlineTest.GET_DAILY_LEARNING_VOCABS_DETAIL, payload.id],
      transformDetail(res),
    );
    onSuccess();
  } catch (ex) {
    showToast({
      icon: 'error',
      title: 'Oops, something went wrong',
      subTitle: ex?.response?.data?.code || ex.message,
    });
  }
};

export const getDailyVocabs = async (query: any) => {
  const { data } = await apis.onlineTest.get(apiUrls.onlineTest.DAILY_LEARNING_VOCABS, query);
  return data;
};



export const createDailyVocabs = async ({ payload }) => {
  const res = await apis.onlineTest.post(apiUrls.onlineTest.DAILY_LEARNING_VOCABS, payload);
  return res.data;
};

export const updateDailyVocabs = async ({ id, payload }) => {
  const { data } = await apis.onlineTest.put(
    apiUrls.onlineTest.DAILY_LEARNING_VOCABS_DETAIL,
    payload,
    {
      params: { id },
    },
  );
  return transformDetail(data);
};

export const deleteDailyVocabs = async (id) => {
  const { data } = await apis.onlineTest.delete(apiUrls.onlineTest.DAILY_LEARNING_VOCABS_DETAIL, {
    id,
  });
  return data;
};

export const activeDailyVocabs = async ({ id, payload }) => {
  const { data } = await apis.onlineTest.put(
    apiUrls.onlineTest.ACTIVE_DAILY_LEARNING_VOCABS_DETAIL,
    payload,
    {
      params: { id },
    },
  );
  return data;
};

export const createProcessDailyVocabs = async ({ payload, onSuccess = noop }) => {
  return processUpdateOrPublishDailyVocabs({
    payload,
    onSuccess,
    apiFn: createDailyVocabs,
  });
};

export const saveDailyVocabs = async ({ payload, onSuccess = noop }) => {
  return processUpdateOrPublishDailyVocabs({
    payload,
    onSuccess,
    apiFn: updateDailyVocabs,
  });
};


